"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserErrCode = void 0;
/**
 * 用户能力相关的错误码
 */
var UserErrCode;
(function (UserErrCode) {
    UserErrCode[UserErrCode["OK"] = 0] = "OK";
    /** 调用jsapi失败 */
    UserErrCode[UserErrCode["ERR_JSAPI_FAILED"] = -1] = "ERR_JSAPI_FAILED";
    /** jsapi没有提前引入 */
    UserErrCode[UserErrCode["ERR_NO_JSAPI"] = -2] = "ERR_NO_JSAPI";
    /** 获取QB登录态失败 */
    UserErrCode[UserErrCode["ERR_ACCOUNT_INFO"] = -3] = "ERR_ACCOUNT_INFO";
    /** 调用getBrowserParam失败 */
    UserErrCode[UserErrCode["ERR_BROWSER_PARAM"] = -4] = "ERR_BROWSER_PARAM";
})(UserErrCode = exports.UserErrCode || (exports.UserErrCode = {}));
